package com.milta.feature.route.domain.entity

/** One stop of a route detail (MIL-38 — `GET /routes/{id}`'s `deliveries[]`). */
data class Delivery(
    val id: String,
    val sortOrder: Int,
    val recipientName: String,
    val address: String,
    val status: DeliveryStatus,
    // MIL-45 — lets the Gestionnaire see which stops still lack GPS coordinates.
    val geocodeStatus: GeocodeStatus,
)
